import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const login = r => require.ensure([], () => r(require('@/page/login/login')), 'login')
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage')
const home = r => require.ensure([], () => r(require('@/page/home/home')), 'home')
// 房源管理
const houseManage = r => require.ensure([], () => r(require('@/page/houseManage/index')), 'houseManage')
// 订单管理
const orderManage = r => require.ensure([], () => r(require('@/page/orderManage/index')), 'orderManage')
//组织管理
const organize = r => require.ensure([], () => r(require('@/page/organize/index')), 'organize')
//字典设置
const dictionary = r => require.ensure([], () => r(require('@/page/dictionary/index')), 'dictionary')
// 操作说明
const operation = r => require.ensure([], () => r(require('@/page/operation/index')), 'operation')
// 查看订单保洁前后图片
const showImgs = r => require.ensure([], () => r(require('@/page/showImgs')), 'showImgs')
const orderDetail = r => require.ensure([], () => r(require('@/page/orderDetail')), 'orderDetail')

const routes = [{
    path: '/',
    component: login
},
{
    path: '/showImgs',
    component: showImgs
},
{
    path: '/orderDetail',
    component: orderDetail
},
{
    path: '/manage',
    component: manage,
    name: '',
    children: [{
        path: '',
        component: home,
        meta: []
    },
    {
        path: '/houseManage',
        name: '房源管理',
        component: houseManage,
        meta: []
    },
    {
        path: '/organize',
        name: '组织管理',
        component: organize,
        meta: []
    },
    {
        path: '/dictionary',
        name: '字典设置',
        component: dictionary,
        meta: []
    },
    {
      path: '/orderManage',
      name: '订单管理',
      component: orderManage,
      meta: [],
    },
    {
      path: '/operation',
      name: '操作说明',
      component: operation,
      meta: [],
    }]
}]

export default new Router({
    mode: 'history',
    routes,
    strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/router/index.js